<ng-container *ngIf="memberCard$ | async as memberCard; else loadingRef">
  <h2 class="accessibility-only">Member Card</h2>
  <div
    *ngIf="memberCard.RetailDiscountLevel != null || memberCard.RetailDiscountLevel != undefined; else default"
    class="member-card text-center d-flex flex-column"
    [ngClass]="{
      'bg-allstar': isFreePopulation,
      'bg-primary': !isFreePopulation,
    }"
  >
    <div class="d-flex justify-content-between">
      <!--Name and ID-->
      <div class="card-id text-start text-white">
        <h2 class="m-0 card-name text-uppercase" *ngIf="memberDetails$ | async as memberDetails">
          {{ memberDetails.FirstName }} {{ memberDetails.Surname }}
        </h2>
        <div class="d-flex font-size-14">
          <div>{{ memberCard.ProductCodeDisplayName || memberCard.ProductCode }}</div>

          <div class="px-1">-</div>
          <div>{{ memberCard.ExternalRefNumber }}</div>
        </div>
      </div>
      <!--Logo-->
      <ng-container *inPopulation="[populations.Default, populations.Partner]">
        <img
          class="card-tier-img"
          *ngIf="tierName == tierLevels.Mvp"
          alt=""
          src="assets/images/tier-logo/tier_logo_mvp.svg"
          draggable="false"
        />
        <img
          class="card-tier-img"
          *ngIf="tierName == tierLevels.AllStar"
          alt=""
          src="assets/images/tier-logo/tier_logo_all_star.svg"
          draggable="false"
        />
        <img
          class="card-tier-img"
          *ngIf="tierName == tierLevels.Legend"
          alt=""
          src="assets/images/tier-logo/tier_logo_legends.svg"
          draggable="false"
        />
        <img
          class="card-tier-img"
          *ngIf="tierName == tierLevels.Pro"
          alt=""
          src="assets/images/tier-logo/tier_logo_pro.svg"
          draggable="false"
        />
      </ng-container>

      <ng-container *inPopulation="[populations.Free]">
        <img
          class="card-tier-img"
          *ngIf="tierName == tierLevels.Mvp"
          alt=""
          src="assets/images/tier-logo/tier_logo_mvp_white.png"
          draggable="false"
        />
        <img
          class="card-tier-img"
          *ngIf="tierName == tierLevels.AllStar"
          alt=""
          src="assets/images/tier-logo/tier_logo_allstar_white.png"
          draggable="false"
        />
        <img
          class="card-tier-img"
          *ngIf="tierName == tierLevels.Legend"
          alt=""
          src="assets/images/tier-logo/tier_logo_legend_white.png"
          draggable="false"
        />
        <img
          class="card-tier-img"
          *ngIf="tierName == tierLevels.Pro"
          alt=""
          src="assets/images/tier-logo/tier_logo_pro_white.png"
          draggable="false"
        />
      </ng-container>
      <ng-container *inPopulation="[populations.Suite, populations.Pts]">
        <img class="card-tier-img" alt="" src="assets/images/mytwins-primary-logo.png" draggable="false" height="40" />
      </ng-container>
    </div>

    <!--Balances-->
    <div class="balance-container text-white">
      <ng-container *notInPopulation="[populations.Suite, populations.Pts]">
        <div class="balance-section bg-glass">
          <span class="material-icons"> loyalty </span>
          <div class="balance-section-content">
            <h4 class="font-size-18 font-heading mb-0">{{ pointsBalance$ | async | number: '1.0-0' }}</h4>
            <div class="font-size-12 mb-0">{{ 'member.card.points.balance' | translate }}</div>
          </div>
        </div>
        <div class="balance-section bg-glass">
          <span class="material-symbols-outlined money-bag-icon"> money_bag </span>
          <div class="balance-section-content">
            <h4 class="font-size-18 font-heading mb-0">{{ combinedCard$ | async | FortressCurrencyPipe }}</h4>
            <div class="font-size-12 mb-0">{{ 'member.card.ecash.balance' | translate }}</div>
          </div>
        </div>
      </ng-container>

      <ng-container *inPopulation="[populations.Suite, populations.Pts]">
        <div class="balance-section bg-glass">
          <span class="material-icons"> fastfood </span>
          <div class="balance-section-content">
            <!--Discount-->
            <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.default.discount'">
              <label class="font-size-18 fw-bold font-heading mb-0">{{ memberCard.DiscountLevel | getNumber }}%</label>
            </ng-container>
            <!--Discount Day F&B-->
            <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.discount.day'">
              <label class="font-size-18 fw-bold font-heading mb-0"
                >{{ 'member.card.discount.day.fandb.value' | translate }}%</label
              >
            </ng-container>
            <div class="font-size-12 mb-0">{{ 'member.card.f&b.discount' | translate }}</div>
          </div>
        </div>
        <div class="balance-section bg-glass">
          <span class="material-icons"> local_mall </span>

          <div class="balance-section-content">
            <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.default.discount'">
              <label class="font-size-18 fw-bold font-heading mb-0">{{ memberCard.RetailDiscountLevel | getNumber }}%</label>
            </ng-container>
            <!--Discount Day Retail-->
            <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.discount.day'">
              <label class="font-size-18 fw-bold font-heading mb-0"
                >{{ 'member.card.discount.day.retail.value' | translate }}%</label
              >
            </ng-container>
            <div class="font-size-12 mb-0">{{ 'member.card.ecash.discount' | translate }}</div>
          </div>
        </div>
      </ng-container>
    </div>

    <!-- Discount -->
    <ng-container *notInPopulation="[populations.Suite, populations.Free, populations.Pts]">
      <div class="discount-container text-white">
        <div class="discount-section text-start">
          <panorama class="font-size-14 mb-0">{{ 'member.card.discountlevel' | translate }}</panorama>
          <!--Discount-->
          <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.default.discount'">
            <label class="font-size-14 fw-bold mb-0">{{ memberCard.DiscountLevel | getNumber }}%</label>
          </ng-container>
          <!--Discount Day F&B-->
          <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.discount.day'">
            <label class="font-size-14 fw-bold mb-0">{{ 'member.card.discount.day.fandb.value' | translate }}%</label>
          </ng-container>
        </div>
        <div class="discount-section text-start">
          <p class="font-size-14 mb-0">{{ 'member.card.discount' | translate }}</p>
          <!--Retail Discount-->
          <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.default.discount'">
            <label class="font-size-14 fw-bold mb-0">{{ memberCard.RetailDiscountLevel | getNumber }}%</label>
          </ng-container>
          <!--Discount Day Retail-->
          <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.discount.day'">
            <label class="font-size-14 fw-bold mb-0">{{ 'member.card.discount.day.retail.value' | translate }}%</label>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </div>
</ng-container>

<ng-container *notInPopulation="[populations.Suite, populations.Pts]">
  <div class="font-size-12 mt-3">
    {{ 'barcode.currency.disclaimer' | translate }}
  </div>
</ng-container>

<ng-template #default>
  <div class="member-card text-white bg-primary">
    <div class="d-flex flex-column justify-content-between h-100">
      <div class="d-flex justify-content-between mt-3">
        <!--Name and ID-->
        <div class="card-id text-start">
          <p class="mb-0 card-name text-uppercase font-size-18" *ngIf="memberDetails$ | async as memberDetails">
            {{ memberDetails.FirstName }} {{ memberDetails.Surname }}
          </p>
          <div class="d-flex font-size-12">
            <div>{{ membercard?.ProductCodeDisplayName || membercard?.ProductCode }}</div>
            <div class="px-1">-</div>
            <div>{{ memberCard.ExternalRefNumber }}</div>
          </div>
        </div>
        <!--Logo-->
        <img alt="" class="card-logo" src="assets/images/Twins_logo.svg" draggable="false" />
      </div>
    </div>
  </div>
</ng-template>
<ng-template #loadingRef>
  <fgbcl-loading></fgbcl-loading>
</ng-template>
